import moment from 'moment'
import { DATE } from '@/constants/constants'
import { uiHelper } from '@/utils'

export default function timeFormat(value) {
  let lang = uiHelper.getLocalStorage('language')
  moment.locale(lang === 'zh' ? 'zh-cn' : lang)
  let result = ''
  if (value != undefined && value != null && value != '') {
    return moment(String(value), ['h:m a', 'H:m']).format(DATE.TIME)
  }

  return result
}
